export const GetReportOptions = (order, user) => {
    if (!order || !user) return [];

    const options = [];




    if (user.role === "PM") {

        // REFUND_DELAY
        if (order.status !== "ORDERED" && order.status !== "REVIEWED" && order.status !== "ON_HOLD" && !order.refund_image_proof_url) {
            options.push({
                option: "Refund Delay",
                value: "REFUND_DELAY"
            });
        }

        // COMMISSION_ISSUE
        if (order.status === "COMPLETED") {

            options.push({
                option: "Commission Issue",
                value: "COMMISSION_ISSUE"
            });


        }

        // LESS_REFUND
        if (order.refund_image_proof_url && order.refund_confirmed !== 1) {
            options.push({
                option: "Less Refund",
                value: "LESS_REFUND"
            });

            options.push({
                option: "Wrong Refund Screenshot",
                value: "WRONG_REFUND_SCREENSHOT"
            });
        }

        options.push({
            option: "Dispute",
            value: "DISPUTE"
        });

    }

    // -----------------------
    // PMM REPORT TYPES
    // -----------------------
    if (user.role === "PMM") {

        // PRODUCT_RETURNED_AFTER_REFUND
        if (order.refund_image_proof_url) {
            options.push({
                option: "Product Returned After Refund",
                value: "PRODUCT_RETURNED_AFTER_REFUND"
            });
        }
        if (order.status !== "ORDERED") {
            options.push({
                option: "Negative Review",
                value: "NEGATIVE_REVIEW"
            });
        }
    }

    // -----------------------
    // AVAILABLE TO EVERYONE
    // -----------------------
    options.push({
        option: "Other Issue",
        value: "OTHER_ISSUE"
    });

    return [
        { option: "Select Report Type", value: "" },
        ...options
    ];
};